<template>
  <b-container fluid>
    <b-modal size="lg" title="Non-Disclosure Agreement" v-model="show" hide-footer>
      <h5> Dengan ini saya menyetujui bahwa:</h5>
      <ol>
        <li>
          <h6>Seluruh Tarif dan Dokumen Internal yang terdapat di Product Catalog bersifat
          <b>rahasia</b>
          <i>(confidential)</i>,
          terbatas hanya untuk karyawan Telkom.</h6>
        </li>
        <li>
          <h6>Berkewajiban menjaga kerahasiaan informasi Product Catalog.</h6>
        </li>
        <li>
          <h6>
            Tidak menyalahgunakan informasi yang diperoleh sehingga menyebabkan
            gangguan, hingga kerugian bagi perusahaan.
          </h6>
        </li>
        <li>
          <h6>
            Bertanggung jawab apabila terjadi penggunaan yang tidak benar terhadap
            informasi tersebut.
          </h6>
        </li>
      </ol>
      <b-form-checkbox class="mt-2" v-model="isChecked">Saya menyetujui dan memahami <b>Non-Disclosure Agreement</b> di atas</b-form-checkbox>
      <div class="d-flex justify-content-center align-items-center">
        <b-button size="sm" variant="light" class="mt-3 mr-2 w-25">Cancel</b-button>
        <b-button size="sm" @click="authorizedDownload" variant="primary" class="mt-3 w-25">Ok</b-button>
      </div>
    </b-modal>
    <b-card>
      <b-card-text>
        <b-row class="mb-2 d-flex flex-wrap align-items-center">
          <b-col class="d-flex justify-content-center mb-2 mb-md-0">
            <b-button @click="toggleCollapse" v-b-toggle.filter-collapse size="sm" variant="outline-dark" class="w-100">
              <b-img style="width:23px; color:white !important" :src="filterIcon" />
              Filter
              <span class="toggleUpDown ml-2" :class="{ rotate: isCollapse }">&#9662;</span>
            </b-button>
          </b-col>
          <b-col class="d-flex justify-content-center mb-2 mb-md-0">
            <b-button @click="resetFilters" variant="outline-primary" class="w-100">
              Clear
            </b-button>
          </b-col>
          <b-col cols="12" md="6">
            <b-form-input
              style="width:100%; margin-right:20px" 
              id="search-input"
              v-model="searchWord"
              placeholder="Search Nota Dinas" 
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-collapse id="filter-collapse">
              <b-card border-variant="dark">
                <b-card-text>
                  <b-row>
                    <b-col cols="12" md="3" class="mb-2 mb-md-0">
                      <h6 style="font-weight:600; color:black">Portfolio</h6>
                      <div class="button-group">
                        <b-button variant="outline-dark" class="idx-button btn-equal i-0"  @click="selectCategory('Communication')">Communication</b-button>
                        <b-button variant="outline-dark" class="idx-button btn-equal i-1" @click="selectCategory('Internet')">Internet</b-button>
                        <b-button variant="outline-dark" class="idx-button btn-equal i-2" @click="selectCategory('Datacomm')">DataComm</b-button>
                        <b-button variant="outline-dark" class="idx-button btn-equal i-3" @click="selectCategory('Wireless')">Wireless</b-button>
                        <b-button variant="outline-dark" class="idx-button btn-equal i-8" @click="selectCategory('Cyber Security')">Cyber Security</b-button>
                      </div>
                    </b-col>
                    <b-col cols="12" md="3" class="mb-2 mb-md-0">
                      <h6 style="font-weight:600; color:black">Type</h6>
                      <div class="button-group three-buttons">
                        <b-button variant="outline-dark" class="idx-button btn-equal i-4" @click="selectType('Penetapan')">Penetapan</b-button>
                        <b-button variant="outline-dark" class="idx-button btn-equal i-5" @click="selectType('GTM')">GTM</b-button>
                        <b-button variant="outline-dark" class="idx-button btn-equal i-6"
                        @click="selectType('Retirement')">Retirement</b-button>
                      </div>
                    </b-col>
                    <b-col cols="12" md="3" lg="4" class="">
                      <h6 style="font-weight:600; color:black">Document Date</h6>
                      <div class="d-flex flex-row flex-wrap flex-lg-nowrap" style="gap: 10px;">
                        <date-picker 
                          v-model="startDate"
                          type="date" 
                          format="YYYY-MM-DD"
                          :valueType="'format'"
                          placeholder="Start Date"
                          @panel-change="onPanelChange"
                          class="flex-grow-1"
                        />
                        <date-picker 
                          v-model="endDate"
                          type="date" 
                          format="YYYY-MM-DD"
                          placeholder="end Date"
                          :valueType="'format'"
                          @panel-change="onPanelChange"
                          class="flex-grow-1"
                        />
                      </div>
                    </b-col>
                    <b-col cols="12" md="3" lg="2" class="mb-2 mb-md-0">
                      <b-button variant="outline-dark" class="w-100 mt-2 idx-button btn-equal i-7" @click="selectFavorite">
                        <span><feather-icon class="mr-1" size="14" icon="StarIcon" />Favorit</span>
                      </b-button>
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-card>
            </b-collapse>
          </b-col>
        </b-row>
        <div v-if="selectedRows.length > 0" class="mb-1">
          <b-alert show variant="light" style="color:black" class="d-flex">
            <span @click="deleteSelected"><feather-icon class="" size="18" icon="XIcon" /></span>
            <span class="ml-2">{{ selectedRows.length }} Selected</span>
            <span v-if="!loadFavorite" @click="multipleFavorite" style="cursor:pointer"><feather-icon class="ml-1" size="18" icon="StarIcon" /></span>
            <span v-else class="ml-1"><indicatorLoad /></span>
            <span v-if="!loadDownload" @click="multipleDownload" style="cursor:pointer">
              <feather-icon class="ml-1" size="18" icon="DownloadIcon" />
            </span>
            <span v-else class="ml-1"><indicatorLoad /></span>
          </b-alert>
        </div>
        <!-- Larger screen than mobile -->
        <div class="d-none d-md-flex">
          <b-table responsive :items="nodinData" :fields="fields" :busy="isBusy" @row-clicked="selectRow" :tbody-tr-class="rowClass" @sort-changed="onSortChanged" class="w-100">
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
                <strong class="text-secondary">Loading...</strong>
              </div>
            </template>
            <template #cell(action)="nodinData">
              <div class="d-flex justify-content-start">
                <b-link @click="toggleFavorite(nodinData.index, nodinData.item.id)">
                  <feather-icon
                    :style="{ color: 'red', fill: nodinData.item.favorite ? 'red' : 'none', stroke: nodinData.item.favorite ? 'none' : 'red' }"
                    class="favoritIcons mt-1 mx-2"
                    icon="StarIcon"
                    fill="true"
                  />
                </b-link> 
                <b-button @click="singleDownload(nodinData.item.path)" v-ripple.400="'rgba(255, 255, 255, 0.15)'" class="btn-icon mr-1" size="md" variant="primary">
                  <span><feather-icon size="14" icon="DownloadIcon" /></span>
                </b-button>
              </div>
            </template>
            <template #cell(name)="nodinData">
              <div :inner-html.prop="nodinData.item.name"></div>
            </template>
            <template #cell(category)="nodinData">
              <div :inner-html.prop="nodinData.item.category"></div>
            </template>
            <template #cell(type)="nodinData">
              <div :inner-html.prop="nodinData.item.type_nd"></div>
            </template>
            <template #cell(documentDate)="nodinData">
              <div :inner-html.prop="nodinData.item.date"></div>
            </template>
          </b-table>
        </div>
        <!-- Mobile screen -->
        <div class="d-flex d-md-none flex-column">
          <!-- Loading -->
          <div v-if="isBusy" class="text-center text-danger my-2">
            <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
            <strong class="text-secondary">Loading...</strong>
          </div>
          <!-- Data -->
          <div v-if="!isBusy && nodinData.length == 0" class="text-center text-danger my-2">
            <strong class="text-secondary">No data</strong>
          </div>
          <b-row
            v-if="!isBusy && nodinData.length > 0"
            v-for="(item, index) in nodinData"
            :key="item.id"
            :class="['mb-3', 'list-item', rowClass(item)]"
            @click="selectRow(item, index)"
            style="cursor: pointer;"
          >
            <b-col cols="12" class="d-flex flex-wrap justify-content-end align-items-center mb-1" style="gap: 1rem;">
              <strong class="flex-grow-1 truncate">{{ item.name }}</strong>
              <div>
                <b-link @click="toggleFavorite(index, item.id)">
                  <feather-icon
                    :style="{ color: 'red', fill: item.favorite ? 'red' : 'none', stroke: item.favorite ? 'none' : 'red' }"
                    class="favoritIcons mt-1 mx-2"
                    icon="StarIcon"
                    fill="true"
                  />
                </b-link> 
                <b-button @click="singleDownload(item.path)" v-ripple.400="'rgba(255, 255, 255, 0.15)'" class="btn-icon mr-1" size="md" variant="primary">
                  <span><feather-icon size="14" icon="DownloadIcon" /></span>
                </b-button>
              </div>
            </b-col>
            <b-col cols="12" class="d-flex flex-wrap">
              <div style="font-size: 0.75rem;">
               <p>
                   <strong>PORTFOLIO: </strong>
                   <span :inner-html.prop="item.category"></span>
                 </p>
                <p>
                  <strong>TYPE: </strong>
                  <span :inner-html.prop="item.type_nd"></span>
                </p>
                <p>
                  <strong>DOCUMENT DATE: </strong>
                  <span :inner-html.prop="item.date"></span>
                </p>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">
              Showing {{ pagination.from }} to {{ pagination.to }} of
            {{ pagination.total }} entries
            </span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="pagination.total"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
              @input="changePage"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
  </b-container>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import { generateToken } from '@/auth/helperAuth'
import {
  BCard, BCardText,BLink,BAvatar,BRow,BCol,BTabs, BTab, BButton, BFormDatepicker, BFormInput, BFormSelect, BPagination, VBModal, BFormCheckboxGroup, BFormGroup, BFormCheckbox, BButtonGroup,
  BImg,
  BCollapse,
  VBToggle,
  VBTogglePlugin,
  BTable,
  BAlert,
  BTooltip
} from 'bootstrap-vue'
import indicatorLoad from './indicatorLoad.vue'
import SkeletonContainer from '../product/components/SkeletonContainer.vue'
// import Datepicker from 'vuejs-datepicker'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from "moment"

export default {
  components: {
    DatePicker,
    BButton,
    BTabs, 
    BTab,
    BRow,
    BCol,
    BCard,
    BPagination,
    BAvatar,
    BLink,
    VBModal,
    BCardText,
    SkeletonContainer, BFormDatepicker, BFormInput, BFormSelect,
    BFormCheckboxGroup, BFormGroup, BFormCheckbox, BButtonGroup, BImg, BCollapse,VBToggle, VBTogglePlugin, BTable, BAlert, indicatorLoad, BTooltip
  },
  data() {
    return {
      token: '',
      filterIcon: require('@/assets/images/icons/filter.png'),
      refreshIcon: require('@/assets/images/icons/cancel.png'),
      isCollapse: false,
      isBusy: false,
      downloadPath: '',
      isChecked: null,
      startDate: '',
      endDate: '',
      uploadDate: '',
      nodinData: [],
      currentPage: 1,
      perPage: 10,
      searchWord: '',
      show: false,
      variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark'],
      headerBgVariant: 'danger',
      headerTextVariant: 'light',
      bodyBgVariant: 'light',
      bodyTextVariant: 'dark',
      footerBgVariant: 'warning',
      footerTextVariant: 'dark',
      pagination: {
        from: 1,
        to: 10,
        total: 0,
      },
      fields: [
         { key: 'name', sortable: true },
         { key: 'category', label: 'Portfolio', sortable: true },
         { key: 'type', sortable: true},
         { key: 'documentDate', sortable: true},
         'action',
       ],
      selectedCategory: null,
      selectedType: null,
      isFavoriteSelected: false,
      selectedRows: [],
      loadFavorite:false,
      loadDownload:false,
      sortField: '',
      orderBy: '',
      statusDownload: '',
    }
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle 
  },
  watch: {
    perPage() {
      this.fetchNodin()
    },
    currentPage() {
      this.fetchNodin()
    },
    searchWord() {
      this.fetchNodin()
    },
    uploadDate(){
      this.fetchNodin()
    },
    endDate(){
      this.fetchNodin()
    },
    selectedType(){
      this.fetchNodin()
    },
    selectedCategory(){
      this.fetchNodin()
    },
    isFavoriteSelected(){
      this.fetchNodin()
    },
    orderBy(){
      this.fetchNodin()
    },
    sortField(){
      this.fetchNodin()
    },
  },
  created() {
    const payload = {
      client: "product-catalog-fe",
      kode: this.$store.getters['oauth/getActiveUser'].id.toString(),
      user: this.$store.getters['oauth/getActiveUser'].name,
      role: this.$store.getters['oauth/getActiveUser'].role,
    }
    this.token = generateToken(payload)
  },
  mounted(){
    this.fetchNodin()
    const vm = this
    document.querySelectorAll('.button-group .i-0, .button-group .i-1, .button-group .i-2, .button-group .i-3, .button-group .i-8').forEach((button) => {
      button.addEventListener('click', function() {
        if (this.classList.contains('active')) {
          this.classList.remove('active')
          this.style.backgroundColor = 'white'
          vm.selectCategory(null)
        } else {
          document.querySelectorAll('.button-group .i-0, .button-group .i-1, .button-group .i-2, .button-group .i-3, .button-group .i-8').forEach((btn) => {
            btn.classList.remove('active')
            this.style.backgroundColor = 'white'
          })
          this.classList.add('active')
          vm.selectCategory(this.textContent.trim())
        }
      })
    })
    document.querySelectorAll('.button-group .i-4, .button-group .i-5, .button-group .i-6').forEach((button) => {
      button.addEventListener('click', function() {
        if (this.classList.contains('active')) {
          this.classList.remove('active')
          this.style.backgroundColor = 'white'
          vm.selectType(null)
        } else {
          document.querySelectorAll('.button-group .i-4, .button-group .i-5, .button-group .i-6').forEach((btn) => {
            btn.classList.remove('active')
            this.style.backgroundColor = 'white'
          })
          this.classList.add('active')
          vm.selectType(this.textContent.trim())
        }
      })
    })
    const favoritButton = document.querySelector('.i-7')
    favoritButton.addEventListener('click', function() {
      this.classList.toggle('active')
      if (!this.classList.contains('active')) {
        this.style.backgroundColor = 'white'
      }
    })
  },
  computed: {
    formattedStartDate: {
      get() {
        return this.startDate
          ? moment(this.startDate).format("YYYY-MM-DD")
          : null;
      },
      set(value) {
        this.startDate = moment(value, "YYYY-MM-DD").toDate();
      },
    },
    formattedEndDate: {
      get() {
        return this.endDate
          ? moment(this.endDate).format("YYYY-MM-DD")
          : null;
      },
      set(value) {
        this.endDate = moment(value, "YYYY-MM-DD").toDate();
      },
    },
  },
  methods: {
    customFormatter(date) {
      return moment(date).format('YYYY-MM-DD')
    },
    onPanelChange(panel) { 
      if (panel === 'year') {
        this.$nextTick(() => { 
          const btnLeft = document.querySelector('.mx-btn-icon-double-left')
          const btnRight = document.querySelector('.mx-btn-icon-double-right')
          $(btnLeft).click(() => {
            const yearCells = document.querySelectorAll('.mx-calendar-content .mx-table-year .cell');
            yearCells.forEach(cell => { 
              const currentYear = new Date().getFullYear()
              const year = parseInt(cell.getAttribute('data-year'))
              if (year < 2000 || year > currentYear) { 
                cell.classList.add('disabled')
              } else { 
                cell.classList.remove('disabled')
              }
            })
          })
          $(btnRight).click(() => {
            const yearCells = document.querySelectorAll('.mx-calendar-content .mx-table-year .cell');
            yearCells.forEach(cell => { 
              const currentYear = new Date().getFullYear(); 
              const year = parseInt(cell.getAttribute('data-year'))
              if (year < 2000 || year > currentYear) { 
                cell.classList.add('disabled')
              } else { 
                cell.classList.remove('disabled')
              }
            })
          })
          const yearCells = document.querySelectorAll('.mx-calendar-content .mx-table-year .cell');
            yearCells.forEach(cell => { 
              const currentYear = new Date().getFullYear(); 
              const year = parseInt(cell.getAttribute('data-year'))
              if (year < 2000 || year > currentYear) { 
                cell.classList.add('disabled')
              } else { 
                cell.classList.remove('disabled')
              }
            })
          })
        }
    },
    fetchNodin() {
      this.isBusy = true
      this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/attachment/list`, {
        params: {
          page: this.currentPage,
          perPage: this.perPage,
          order: this.sortCriteria,
          type:'NotaDinas',
          sort: (this.sortField !== '') ? this.sortField : 'date',
          order: (this.orderBy !== '') ? this.orderBy : 'DESC',
          type_nd:this.selectedType,
          startDate: this.startDate,
          endDate: this.endDate,

          category: this.selectedCategory,
          s: this.searchWord.toString().trim(),
          favorite_user: this.$store.getters['oauth/getActiveUser'].id,
          favorite: this.isFavoriteSelected,
          createdDate : this.uploadDate
        },
        withCredentials: true,
        headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
      })
      .then(response => {
        this.pagination.from = response.data.from
        this.pagination.to = response.data.to
        this.pagination.total = response.data.total
        this.currentPage = response.data.current_page
        this.nodinData = response.data.data.map(item => ({
        ...item,
        }))
      })
      .finally(() => {
        this.isBusy = false
      })
    },
    singleDownload(path) {
      this.downloadPath = path
      this.statusDownload = 'single'
      this.show = true
    },
    async authorizedDownload() {
      if(this.isChecked && this.statusDownload == 'single'){
        try {
          const response = await fetch(`${process.env.VUE_APP_API_HELPER_URL}/attachment?path=${encodeURIComponent(this.downloadPath)}`, {
            method: 'GET',
            headers: {
              'Authorization': `${this.token}`,
              'Accept': 'application/json',
            },
          })
          if (!response.ok) {
            throw new Error(`Error downloading file: ${response.statusText}`)
          }
          const blob = await response.blob()
          const downloadUrl = URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = downloadUrl
          link.download = this.getFileNameFromPath(this.downloadPath)
          document.body.appendChild(link)
          link.click()

          URL.revokeObjectURL(downloadUrl)
          document.body.removeChild(link)

          this.isChecked = false
          this.show = false
        } catch (error) {
          console.error(error.message)
        }
      }else if(this.isChecked && this.statusDownload == 'multiple'){
        const path = []
        this.show = false
        this.loadDownload = true
        this.selectedRows.forEach(item => { path.push(item.path) })
        const mapRequest = { paths: path }
        this.$http.post(`${process.env.VUE_APP_API_HELPER_URL}/attachment/multiple`, mapRequest, {
          withCredentials: true,
          headers: { 
            'Authorization': `${this.token}`, 
            'Content-Type': 'application/json', 
            'Accept': 'application/zip' 
          },
          responseType: 'blob'
        })
        .then(res => {
            const url = window.URL.createObjectURL(new Blob([res.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'Nota Dinas.zip')
            document.body.appendChild(link)
            link.click()
            link.parentNode.removeChild(link)
            window.URL.revokeObjectURL(url)
            this.selectedRows = []
          })
          .catch(err => {
            if (typeof err.data.errors !== 'undefined') {
              this.$notif('Error', err.data.errors.file[0], 'error')
            }else{
              this.errString = err.data.replace(",","<br>")
              this.$notif('Error', `Something wrong`, 'error')
            }
          })
          .finally(() => (
            this.loadDownload = false
          )
        )
        }else{
        this.$notifOnClick(
          'Forbidden!', 
          "Downloading this file is strictly prohibited. Unauthorized access or distribution of this content is against our policy and may result in serious consequences, including legal action. Please respect these restrictions and do not attempt to download or share this file without proper authorization", 
          'danger', 
          'AlertTriangleIcon',
          'danger',
          'OK',
          () => {})
        this.isChecked = false
        this.show = false
      }
    },
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    resetFilters() {
      this.searchWord = ''
      this.startDate = null
      this.endDate = null
      this.selectedCategory = null
      this.selectedType = null
      this.isFavoriteSelected = false
      document.querySelectorAll('.button-group .btn-equal, .i-7').forEach((btn) => { btn.classList.remove('active')})
      this.fetchNodin()
    },
    toggleFavorite(index, id) {
      const urlApi = this.nodinData[index].favorite ? `${process.env.VUE_APP_API_HELPER_URL}/attachment/notaDinas/favorite/remove` : `${process.env.VUE_APP_API_HELPER_URL}/attachment/notaDinas/favorite/add` 
      this.nodinData[index].favorite = !this.nodinData[index].favorite
      const userId = this.$store.getters['oauth/getActiveUser'].id
      this.$http
        .put(urlApi, {
          kode: userId,
          attachmentId: [id],
        },{ 
          headers: { 'Authorization': this.token },
        })
        .then(() => {})
        .catch(({ data }) => {
          this.$notif('Error', `${data.message}`, 'error')
        })
        .finally(() => {
          this.isBusy = false
        })
    },
    selectCategory(category) { this.selectedCategory = category },
    selectType(type) { this.selectedType = type },
    selectFavorite() { this.isFavoriteSelected = !this.isFavoriteSelected },
    changePage(page) { 
      this.currentPage = page
    },
    selectRow(item, index) {
      const foundIndex = this.selectedRows.findIndex(row => row.id === item.id)
      if (foundIndex === -1) {
        this.selectedRows.push(item)
      } else {
        this.selectedRows.splice(foundIndex, 1)
      }
    },
    rowClass(item) {
      return this.selectedRows.some(row => row.id === item.id) ? 'table-row-selected' : 'pointer-row';
    },
    deleteSelected() {
      this.selectedRows = []
    },
    multipleFavorite() {
      this.loadFavorite = true
      const userId = this.$store.getters['oauth/getActiveUser'].id
      const id = []
      this.selectedRows.forEach(item => { id.push(item.id) })
      const mapRequest = { kode: userId, attachmentId: id }
      this.$http.put(`${process.env.VUE_APP_API_HELPER_URL}/attachment/notaDinas/favorite/multiple`, mapRequest, {
        withCredentials: true,
        headers: { 
          'Authorization': `${this.token}`, 
          'Content-Type': 'application/json', 
        },
      })
      .then(res => {
          if(res.status == 200){
            this.fetchNodin()
            this.selectedRows = []
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => (this.loadFavorite = false)
      )
    },
    multipleDownload(){
      this.show = true
      this.statusDownload = 'multiple'
    },
    onSortChanged(ctx){
      if(ctx.sortBy == 'category'){
        this.sortField = 'pc.name'
      }else if(ctx.sortBy == 'type') {
        this.sortField = 'nd.type'
      }else if(ctx.sortBy == 'documentDate'){
        this.sortField = 'date'
      }else{
        this.sortField = ctx.sortBy
      }
      this.orderBy = ( (ctx.sortDesc == false ) ? 'ASC' : 'DESC')
    },
    getFileNameFromPath(path) {
      return path.split('/').pop()
    },
  }
}
</script>

<style>
.table-row-selected {
  background-color: #f7d5d5 !important;
  cursor: pointer;
}
.pointer-row{
  cursor: pointer;
}
.b-avatar.badge-light-danger {
  background-color: red;
  color: white
}

.title {
  color:black;
}

.no-data > .card-body{
  padding:1rem !important;
}

.no-data > .card-body > .card-title{
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-size: 1.2em;
  color: gray;
}

.modal-title {
  color:white !important;
  font-weight: 600
}
.button-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.button-group.three-buttons .btn-equal:first-child {
  flex-basis: 100%;
}

.btn-equal {
  flex: 1 1 142px;
  height: 40px;
}

.btn-equal:hover {
  background-color: #D92C2F !important;
  border-color: #D92C2F !important;
  color: white !important;
}

.btn-equal.active {
  background-color: #D92C2F !important;
  border-color: #D92C2F !important;
  color: white !important;
}

.toggleUpDown {
  display: inline-block;
  transition: transform .3s ease-in-out !important;
}

.toggleUpDown.rotate {
  transform: rotate(180deg) !important;
}

.fill-favorit {
  fill:#D92C2F; 
  stroke:none;
}

.stroke-favorit {
  fill:none; stroke:#D92C2F;
}

.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>